<template>
  <div id="timeline-chart"  >
    <v-container fluid>
      <v-layout  v-if="fullScreen" align-center row justify-space-between>
        <v-flex xs1 class="text-xs-left">
          Plants
        </v-flex>
        <v-flex xs5>
          Phase
        </v-flex>
        <v-spacer></v-spacer>
        <!-- <v-flex xs4  class="text-xs-right">
          Active Plants Only &nbsp
        </v-flex>
        <v-switch></v-Switch> -->
      </v-layout>
      <v-layout row  style="height: '60%'; padding-right: '20px'" >
        <v-flex md12 style="width: '90%'">
          <div>
            <GChart  
              :settings="({packages: ['timeline']})"
              type="Line"
              :data="data"
              :options="chartOptions"
              :resizeDebounce="500"
              @ready="onChartReady"
            >
            </GChart>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row style="height: '100%'" v-if="fullScreen">
       
      </v-layout>
    </v-container>
  </div>
</template>

<script >
// :createChart="(el, google) => new google.charts.Bar(el)"
import { GChart } from 'vue-google-charts'
import { sync } from 'vuex-pathify'
import ui from '@/../../coreui/helpers/ui'
import _ from 'lodash'

export default {
  props: ['args'],
  components: {
    GChart,
  },
  watch: {
    dark() {
      // this.colorize()
    },
    args: {
      // immediate: true,
      handler( val, old) {
        // if (this.chart != null) this.chart.draw(val.values, this.chartOptions)
        // this.data = val.values
        // let v = _.cloneDeep(val.values)
        // console.log('v = ', v)
        // this.values = v
        // this.colorize()
        // this.pie.dataset.source = val
      },
      deep: true
    },
  },
  data () {
    return {
      values: [],
      chartsLib: null,
      theme: 'default',
      chart: null
    }
  },
  computed: {
    dark: sync('misc/dark'),
    fullScreen: sync('fullScreen'),
    screenSize () {
      this.myWindow.App.window
    },
    data () {
      // return this.args.values
      return 
        [
          [ 'Washington', new Date(1789, 3, 30), new Date(1797, 2, 4) ],
          [ 'Adams',      new Date(1797, 2, 4),  new Date(1801, 2, 4) ],
          [ 'Jefferson',  new Date(1801, 2, 4),  new Date(1809, 2, 4) ]]
      
    },
    stl () {
      return {
        height: this.args.height,
        width: this.args.width
      }
    },
    chartOptions () {
      if (!this.chartsLib) return null
      return {
        backgroundColor: ui.theme(this.dark).lighterbg,
        // backgroundColor: '#ffd',
        timeline: {
          rowLabelStyle:  ui.theme(this.dark).legend,
          barLabelStyle:  ui.theme(this.dark).legend,
          groupByRowLabel: true,
          showRowLabels: true,
          colorByRowLabel: false
        },
        //width: "90%", //this.fullScreen ? this.screenSize.width : this.args.width ,
        height: this.args.height * 0.7,
        // width: this.args.width,
        // height: this.args.height,
        // colors: ui.theme(this.dark).palette,
      }
    }
  },
  methods: {         
    colorize() {
      let n = 0
      console.log('colorizing timeline: ', this.args)
      if (!this.args.values) return
      // this.data = this.args.values
      return
      this.data = _.cloneDeep(this.args.values)
      this.data.forEach(i => {
        if (n ==0) {
          i.splice(2, 0, {type: 'string', id: 'style', role: 'style'})
        } else {
          let c = (ui.theme(this.dark).palette)[n]
          i.splice(2, 0, c)
        }
        n ++
      })
      // this.data = this.args.values
      console.log('Timeline chartdata: ', this.data)
    },
    onChartReady (chart, google) {
      // console.log('Bar - onChartReady: ', chart, google)
      this.chartsLib = google
      this.chart = chart
      var container = document.getElementById('timeline-chart')
      var svg = container.querySelectorAll('svg')
      console.log('container, svg: ', container, svg)
      svg.forEach((x) => {
        console.log(x)
        console.log('attribute: ', x.getAttribute('fill)'))
        x.setAttribute('fill', '#ffffff')
      })
      // var svgArray = Array.prototype.slice.call(svg)
      // console.log('svg = ', svg, svg.length, typeof(svg))
      // var x = svg.find(function(i) {
      //   return i.logicalname == 'svg'
      // })
      // console.log('x = ', x)
      // // getElementsByTagName('svg');
      // svgArray.find('[font-size="13"]').attr('fill', '#ffffff')
      var container = document.getElementById('timeline-chart')
      var labels = container.getElementsByTagName('svg');
      console.log('all labels=', labels)
      for (let i = 0; i < labels.length; i++) { 
            console.log('lebal item: ',labels[i]); 
        } 
        console.log('****', labels[0])
      Array.prototype.forEach.call(labels, function(label) {
        console.log('label: ', label)
        // if (label.getAttribute('font-size') === '13') {
          label.setAttribute('fill', '#00ffff')
          console.log('label: ', label.getAttribute('fill'))
        // }
      })
    },
  },
  beforeMount () {
    
  },
  mounted () {
    // console.log(this.name, this.legend, this.values, this.title, this.subtitle)
    // console.log('mounting BarChart', this.date)
    // this.data = []
    // let n = 0
    console.log('Timeline Chartoptions: ', this.chartOptions)
    // this.colorize()
  },
  created () {
  },
  destroyed () {
    // window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>
text {
  color: '#ffffff' !important;
}
</style>